export const projects = [
  {
    url: 'chill',
    projectName: 'Chill',
    projectImage:
      'https://res.cloudinary.com/nahov91/image/upload/f_auto,q_auto/v1536326419/chill.png',
    projectType: 'Progresszív webapp',
    backdropBg:
      'https://res.cloudinary.com/nahov91/image/upload/c_crop,e_blur:1724,f_auto,g_xy_center,h_500,q_auto:good,w_1659,x_0,y_371/v1536841591/screenshot-nahov91.github.io-2018.09.13-14-23-56.png',
    galleryImages: [
      'https://res.cloudinary.com/nahov91/image/upload/v1536841591/screenshot-nahov91.github.io-2018.09.13-14-24-49.png',
      'https://res.cloudinary.com/nahov91/image/upload/f_auto,q_auto/v1536841591/screenshot-nahov91.github.io-2018.09.13-14-23-56.png',
      'https://res.cloudinary.com/nahov91/image/upload/f_auto,q_auto/v1536841591/screenshot-nahov91.github.io-2018.09.13-14-20-56.png',
      'https://res.cloudinary.com/nahov91/image/upload/f_auto,q_auto/v1536841591/screenshot-nahov91.github.io-2018.09.13-14-22-24.png',
    ],
    projectDescription:
      'Chill egy progressive webapp, amely React.js -szel készült a Udacity Front End Web Developer képzés utolsó projektjeként. Az app olyan szolnoki helyeket jelenít meg a térképen, melyek nyugalmas kikapcsolódásra alkalmasak.',
    technologies:
      'JavaScript, CSS3, CSS Grid, React.js, GitHub, Fetch, Google Maps API',
    problemsToSolve:
      'A feladat az volt, hogy készítsünk egy térkép alapú webapp -ot, melyen egy API segítségével kapcsolódó adatokat jelenítünk meg. Térkép szolgáltatásnak Google Maps-et, míg adatforrásnak a Foursquare API-t használtam.  A térképet a react-google-maps nevű npm csomag segítségével jelenítettem meg, melyen keresztül némiképp átláthatóbb volt az adatok menedzselése és a state-ek kezelése. Az adatok komponensek közti továbbításához nem használtam Redux-ot vagy React Context API-t, lévén a hagyományos “prop drilling” módszer megfelelőnek bizonyult. \n A helyszíneket és adataikat a Foursquare Places API-on keresztül kezeltem, így lehetőségem nyílt mind a venue search, mind pedig a venue data kezelésének megismerésére. A venue search segítségével történik a helyek indításkori kilistázása a helyszínek kategóriáinak megfelelően. Ezen helyek listáját lehet tovább szűkíteni az általam készített keresővel. A térképen lévő markerek vagy a lista elemeire kattintva a térképen további információ jelenik meg a hellyel kapcsolatban (legjobb fotó, kategória, kategória ikon, lokáció, kedvelések száma).\n \n A layout megtervezésénél ügyeltem arra, hogy mobil eszközön a lehető legjobb élményt nyújtsa az alkalmazás. Ezen eszközökön a keresőt és a hozzá tartozó listát nem oldalt egy hamburger menüben rejtettem el, hanem egy alulról bármikor felhúzható fiókként működő dizájnt kapott. A layout kialakításánál CSS Grid-et használtam.\n \n A feladat során az alkalmazással és az adatokbetöltésével előforduló hibákat is kezelnünk kellett, hogy a felhasználó tudja, hogy éppen milyen hiba miatt nem tölt be az alkalmazás. \n Ez a projekt kiváló volt arra, hogy megértsem az adatok komponensek közötti átvitelét, illetve, hogy még biztosabb legyek az API adatok fetch-csel való használatában.',
    links: [
      'https://github.com/Nahov91/FEND-P8-Chill',
      'https://nahov91.github.io/',
    ],
  },
  {
    url: 'techno-viz-laboratorium',
    projectName: 'Techno-Víz Laboratórium Kft. Weblap',
    projectImage:
      'https://res.cloudinary.com/nahov91/image/upload/f_auto,q_auto/v1536326419/technoviz.png',
    projectType: 'Weblap',
    backdropBg:
      'https://res.cloudinary.com/nahov91/image/upload/c_crop,e_blur:1724,f_auto,g_xy_center,h_500,q_auto:good,w_1659,x_0,y_371/v1537269128/rolunk_header.jpg',
    galleryImages: [],
    projectDescription:
      'A projekt során a Techno-Víz Laboratórium Kft. Weboldalának felújítása történik. Az oldal WordPress alapú volt korábban, melyen nem is szeretett volna változtatni az ügyfél.',
    technologies:
      'WordPress, CSS, Adobe XD, Adobe Photoshop, Adobe Illustrator',
    problemsToSolve:
      'A korábbi honlap meglehetősen egyszerű volt, melyet nem is használt sokat a cég sem marketing, sem ügyfélszerzési céllal. Az új weblap már jóval több funkcióval fog bírni, teljesen megújul a design, mely modern és átlátható lesz.  Mind a design, mind pedig a funkcionalitás kivitelezése az én feladatom. A weboldalt jelenleg is fejlesztem, így az ügyféllel kötött megegyezésem alapján arról több információt, illetve képeket nem közölhetek e pillanatban.',
    links: [],
  },
  {
    url: 'hitelguru-hungary',
    projectName: 'Hitelguru Hungary Kft.',
    projectImage:
      'https://res.cloudinary.com/nahov91/image/upload/f_auto,q_auto/v1536326419/hitelguru.png',
    projectType: 'Weblap, logo, névjegykártya',
    backdropBg:
      'https://res.cloudinary.com/nahov91/image/upload/c_crop,e_blur:1724,f_auto,g_xy_center,h_500,q_auto:good,w_1659,x_0,y_371/v1536841621/screenshot-hitelguru.com-2018.09.13-14-14-33.png',
    galleryImages: [
      'https://res.cloudinary.com/nahov91/image/upload/v1536841621/screenshot-hitelguru.com-2018.09.13-14-14-33.png',
      'https://res.cloudinary.com/nahov91/image/upload/f_auto,q_auto/v1536841622/screenshot-hitelguru.com-2018.09.13-14-17-05.png',
      'https://res.cloudinary.com/nahov91/image/upload/f_auto,q_auto/v1536841622/screenshot-hitelguru.com-2018.09.13-14-09-53.png',
      'https://res.cloudinary.com/nahov91/image/upload/f_auto,q_auto/v1536841621/screenshot-hitelguru.com-2018.09.13-14-12-51.png',
    ],
    projectDescription:
      'A projekt során a cég digitális profiljának a felépítése volt a cél, ennek megfelelően a logó, a weblap és az arculat elkészítése is az én feladatom volt. A digitális termékeken kívül még egy névjegykártyát is terveztem az ügyfélnek.',
    technologies:
      'WordPress, CSS, Adobe XD, Adobe Photoshop, Adobe Illustrator',
    problemsToSolve:
      'A HitelGuru Hungary Kft. egy banki szolgáltatásokat közvetítő budapesti cég, mely 2017-ben alakult. Az induláshoz mindenképp szükségük volt egy weboldalra, melyet szolgáltatásuk bemutatására, valamint a leendő ügyfeleikkel történő kapcsolatfelvételre kívántak használni. A várt felhasználóibázist többnyire fiatal felnőttek alkották, ez ihlette a cég arculatát. A szimmetrikus logó kiegyensúlyozottságot, míg a színek megbízhatóságot sugallanak. \n\n A weboldal tervezésénél felmerülő funkciók között nem csak az értékesítés, a marketing és a kapcsolatfelvétel, hanem egy a bankvilági fogalmakkal kapcsolatos tudástár is szerepelt. Ez a tudástár egy kereső funkciót is kapott. \n\n Az oldal alapját WordPress képezi, melynek fő oka az volt, hogy a vállalatnál dolgozók is tudjanak módosítani a tartalmán, amennyiben egy kisebb változtatásra van szükség a szövegben. Az oldalhoz az eredeti megalkotása óta több új funkciót is elkészítettem.',
    links: ['https://hitelguru.com/'],
  },
]

export const homeNavigationData = [
  {
    title: 'About me',
    id: 'iuhiudfh',
    url: 'aboutme',
  },
  {
    title: 'Projects',
    id: 'tyuiolmgjyu',
    url: 'projects',
  },
  {
    title: 'Technologies',
    id: 'fcgvb',
    url: 'technologies',
  },
  {
    title: 'Contact',
    id: 'huygtfdcgv',
    url: 'contact',
  },
]

export const subNavigationData = [
  {
    title: '❮ Back',
    id: 'iuhiudfh',
    url: '/',
  },
]

export const startScreenData = {
  title: '<h1>Gabor <br/>Nahoczki</h1>',
  subtitle:
    'Elevating brands with elegant digital experiences — Frontend Developer specializing in React & Next.js.',
}

export const projectsListData = [
  {
    id: 'iusdiuhsd',
    title: 'BBC News App',
    description:
      'A React Native app delivering seamless news streaming to millions. Award-winning UX, real-time updates, and smooth video playback across iOS & Android.',
    url: 'bbc-news-app',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738583322/cvapp2025/projects/svg/BBC_logo.svg',
  },
  {
    id: 'sddssdsd',
    title: 'BBC News Website',
    description:
      'The BBC News Website redesign offers a seamless way to access live and archived news, optimized for desktop and mobile with a dynamic, intuitive user experience.',
    url: 'bbc-news-website',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738583322/cvapp2025/projects/svg/BBC_logo.svg',
  },
  {
    id: 'weweweeww',
    title: 'Mediabank',
    description:
      'NEP Mediabank is a cloud-based media asset management platform enabling live ingest, automation, real-time collaboration, and instant clip creation for live events.',
    url: 'nep-mediabank',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738583348/cvapp2025/projects/svg/mediabank_logo.svg',
  },
  {
    id: 'erreerre',
    title: 'SPECTRAL',
    description:
      "SPECTRAL's new website and CMS showcase their high-end VFX work for Netflix & Apple TV, featuring a horizontal scrolling layout and a custom dashboard.",
    url: 'spectral',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738583350/cvapp2025/projects/svg/spectral_logo.svg',
  },
  {
    id: 'rttrtrtr',
    title: 'GreenLine Clean',
    description:
      "GreenLine Clean's CMS optimizes washer scheduling, efficiency tracking, and customer management, featuring a custom calendar system and a highly responsive UI.",
    url: 'greenline-clean',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738583350/cvapp2025/projects/svg/greenline_logo.png',
  },
  {
    id: 'tyytyttytyyt',
    title: 'FarkasTent',
    description:
      'FarkasTent’s webshop offers an easy way to purchase or rent motorsports tents, with a CMS for content management and optimized performance for a seamless experience.',
    url: 'farkastent',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738583349/cvapp2025/projects/svg/farkastent_logo.svg',
  },
  {
    id: 'jijijjjijiji',
    title: 'Unleash',
    description:
      'Unleash is a global HR-Tech leader connecting innovators and top exhibitors through dynamic, SEO-optimized web solutions built with React and Node.js.',
    url: 'unleash',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738583322/cvapp2025/projects/svg/unleash_logo.svg',
  },
]

export const aboutMeData = {
  title: 'About me',
  description: `<p>I'm a passionate Frontend Developer with a keen eye for detail and a drive for excellence. Over the years, I've collaborated with innovative teams and global brands—from award-winning news apps and dynamic HR platforms to cutting-edge media management systems and engaging e-commerce experiences. My work centers on crafting intuitive, performance-optimized interfaces that not only look great but also deliver a seamless user experience.</p>
<br />
<p>I specialize in modern JavaScript frameworks and libraries like React and Next.js, harnessing the power of TypeScript, Styled Components, and tools like Framer Motion to bring ideas to life. I love creating elegant and beautiful user interfaces that make the brand proud and the users familiar and happy. Whether it’s developing feature-rich UI components, implementing robust state management, or ensuring lightning-fast performance with lazy loading and memoization, I thrive on turning complex challenges into elegant digital solutions.</p>
<br />
<p>Always eager to learn and innovate, I continuously refine my craft and stay ahead of industry trends. My goal is to build digital experiences that resonate with users, drive results, and make a lasting impact in the ever-evolving tech landscape.</p>
`,
  image:
    'https://res.cloudinary.com/nahov91/image/upload/v1738689150/cvapp2025/about_me/IMG_5415_3.jpg',
}

export const technologiesData = [
  {
    id: 'sdsdsd',
    title: 'React.js',
    description:
      'React.js is a JavaScript library for building user interfaces. It is maintained by Facebook and a community of individual developers and companies.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1736357840/React_2.svg',
  },
  {
    id: 'kllklkkl',
    title: 'Next.js',
    description:
      'React.js is a JavaScript library for building user interfaces. It is maintained by Facebook and a community of individual developers and companies.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738661089/cvapp2025/technologies/nextjs-icon.svg',
  },
  {
    id: 'ghghghgh',
    title: 'Styled Components',
    description:
      'Styled Components is a CSS-in-JS library that allows you to write actual CSS code to style your components. It is a way to write CSS that’s scoped to a single component, and not leak to any other element in the page.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1736358286/2c86f6-styled-components.svg',
  },
  {
    id: 'csscsscss',
    title: 'CSS 3',
    description:
      'Styled Components is a CSS-in-JS library that allows you to write actual CSS code to style your components. It is a way to write CSS that’s scoped to a single component, and not leak to any other element in the page.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738667091/cvapp2025/technologies/css-3.svg',
  },
  {
    id: 'jssjsjsjsjjs',
    title: 'JavaScript',
    description:
      'Styled Components is a CSS-in-JS library that allows you to write actual CSS code to style your components. It is a way to write CSS that’s scoped to a single component, and not leak to any other element in the page.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738667084/cvapp2025/technologies/logo-javascript.svg',
  },
  {
    id: 'tsttststtstst',
    title: 'TypeScript',
    description:
      'Styled Components is a CSS-in-JS library that allows you to write actual CSS code to style your components. It is a way to write CSS that’s scoped to a single component, and not leak to any other element in the page.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738667083/cvapp2025/technologies/typescript.svg',
  },
  {
    id: 'gfgfgffg',
    title: 'Redux',
    description:
      'Redux is a predictable state container for JavaScript apps. It helps you write applications that behave consistently, run in different environments (client, server, and native), and are easy to test.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1736358078/redux.svg',
  },
  {
    id: 'jhjhhjjh',
    title: 'Material UI',
    description:
      'Material-UI is a simple and customizable component library to build faster, beautiful, and more accessible React applications. It is based on Google’s Material Design.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1736358353/material-ui-1.svg',
  },
  {
    id: 'jkkjjkkj',
    title: 'Framer Motion',
    description:
      'Framer Motion is a production-ready motion library for React. Utilize the power behind Framer, the best prototyping tool for teams. Create and share interactive designs for websites, mobile apps, voice assistants, and more.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1736358438/framer-motion.svg',
  },
  {
    id: 'sddssdf',
    title: 'React Native',
    description:
      'React Native is a JavaScript framework for writing real, natively rendering mobile applications for iOS and Android. It’s based on React, Facebook’s JavaScript library for building user interfaces, but instead of targeting the browser, it targets mobile platforms.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1736358003/react-native-seeklogo.svg',
  },
  {
    id: 'iooioioi',
    title: 'React Testing Library',
    description:
      'React.js is a JavaScript library for building user interfaces. It is maintained by Facebook and a community of individual developers and companies.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738661295/cvapp2025/technologies/react_testing_library_logo.png',
  },
  {
    id: 'ioodssdioioi',
    title: 'Storybook',
    description:
      'React.js is a JavaScript library for building user interfaces. It is maintained by Facebook and a community of individual developers and companies.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738666301/cvapp2025/technologies/storybook-icon-svgrepo-com.svg',
  },
  {
    id: 'opopopoppopo',
    title: 'Redux Saga',
    description:
      'React.js is a JavaScript library for building user interfaces. It is maintained by Facebook and a community of individual developers and companies.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738666301/cvapp2025/technologies/redux-saga.svg',
  },
  {
    id: 'stststststs',
    title: 'Stripe API',
    description:
      'React.js is a JavaScript library for building user interfaces. It is maintained by Facebook and a community of individual developers and companies.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738666301/cvapp2025/technologies/stripe-svgrepo-com.svg',
  },
  {
    id: 'ememememem',
    title: 'Emotion',
    description:
      'React.js is a JavaScript library for building user interfaces. It is maintained by Facebook and a community of individual developers and companies.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738667808/cvapp2025/technologies/emotion.png',
  },
  {
    id: 'twtwtwwttw',
    title: 'Tailwind CSS',
    description:
      'React.js is a JavaScript library for building user interfaces. It is maintained by Facebook and a community of individual developers and companies.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738667993/cvapp2025/technologies/tailwind-css-2.svg',
  },
  {
    id: 'pspppsppspps',
    title: 'PageSpeed Insights',
    description:
      'React.js is a JavaScript library for building user interfaces. It is maintained by Facebook and a community of individual developers and companies.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738668224/cvapp2025/technologies/google-pagespeed-insights-icon-2021-.svg',
  },
  {
    id: 'figfigfigfig',
    title: 'Figma',
    description:
      'React.js is a JavaScript library for building user interfaces. It is maintained by Facebook and a community of individual developers and companies.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738668224/cvapp2025/technologies/figma-icon.svg',
  },
  {
    id: 'dododdodoo',
    title: 'Docker',
    description:
      'React.js is a JavaScript library for building user interfaces. It is maintained by Facebook and a community of individual developers and companies.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738666796/cvapp2025/technologies/docker-4.svg',
  },
  {
    id: 'agagagagag',
    title: 'Apollo GraphQL',
    description:
      'React.js is a JavaScript library for building user interfaces. It is maintained by Facebook and a community of individual developers and companies.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738676040/cvapp2025/technologies/apollo-graphql.svg',
  },
  {
    id: 'uyghjdfygb',
    title: 'Jest',
    description:
      'React.js is a JavaScript library for building user interfaces. It is maintained by Facebook and a community of individual developers and companies.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738661385/cvapp2025/technologies/jest-js-icon.svg',
  },
  {
    id: 'uerygfdbhnjhgf',
    title: 'Cypress',
    description:
      'React.js is a JavaScript library for building user interfaces. It is maintained by Facebook and a community of individual developers and companies.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/v1738665931/cvapp2025/technologies/cypress-1.svg',
  },
  {
    id: 'pbgpbgpgbpbgp',
    title: 'PocketBase',
    description:
      'React.js is a JavaScript library for building user interfaces. It is maintained by Facebook and a community of individual developers and companies.',
    image:
      'https://res.cloudinary.com/nahov91/image/upload/t_800 wide/v1738675602/cvapp2025/technologies/pocketbase_logo.svg',
  },
]

export const contactSectionData = {
  title: 'Contact',
  description: `<p>If you're interested in collaborating on exciting projects with flexible work options, I'd love to hear from you.</p>
<br />
<p>Please feel free to get in touch via the provided email, and let's explore how we can work together to create something amazing.</p>
`,
  email: 'gabor.nahoczki.dev@gmail.com',
}

export const projectDetailsData = [
  {
    id: 'uihsdiuhisduh',
    galleryHeight: 220,
    url: 'bbc-news-app',
    title: 'BBC News App',
    shortDescription:
      'A React Native app delivering seamless news streaming to millions. Award-winning UX, real-time updates, and smooth video playback across iOS & Android.',
    description: `<p>The <b>BBC News app</b> was built to <b>redefine how millions engage with news daily</b>, offering a seamless way to <b>read, watch, and listen</b> to <b>live and past news</b>. The goal was to present content in an <b>engaging, easy-to-digest format</b> while ensuring a <b>UI that feels familiar yet distinct from competitors</b>.</p>
<br />
<p>As a <b>Software Developer</b>, I contributed to the <b>frontend development</b>, focusing on <b>building and refining UI components, enhancing the user experience, and implementing key business logic</b>.</p>
<br />
<p>Developed in collaboration with a large team of <b>engineers, designers, project managers, and analysts</b>, this was a <b>highly complex, large-scale project</b> requiring <b>extensive effort and innovation</b>.</p>
<br />
<p>The app was built with <b>React Native</b> and <b>Styled Components</b> for a <b>sleek, maintainable UI</b>. It integrates with the <b>BBC API</b> through a <b>middleware layer</b>, ensuring <b>real-time content updates</b>. <b>Context API</b> efficiently manages state, while <b>TypeScript</b> enforces <b>type safety</b> for a more <b>robust codebase</b>.</p>
<br />
<p>To optimize performance, we implemented <b>lazy loading</b> for many parts of the app and utilized <b>memoization</b> to reduce unnecessary re-renders, significantly improving efficiency. We also ensured <b>high code quality and reliability</b> by using <b>React Testing Library</b> for comprehensive frontend testing.</p>
<br />
<p>We used <b>Storybook</b> for <b>UI component development and documentation</b>, allowing for isolated component testing and easier collaboration across teams. This also helped us create a robust UI library for future scalability.</p>
<br />
<p>A major challenge was achieving <b>seamless video streaming across both iOS and Android</b>. To overcome this, we developed <b>custom modules and performance optimizations</b>, ensuring <b>smooth playback</b> and a <b>responsive experience</b>. Additionally, <b>animations and transitions</b> were carefully designed to create a <b>fluid, intuitive user experience</b>.</p>
<br />
<p>The results? <b>Millions of users rely on this app daily</b>, and its impact was recognized with a <b>Silver Award at the 2024 BIMA Awards in the UX category</b>.</p>
`,
    technologies: [
      'React Native',
      'TypeScript',
      'Context API',
      'Styled Components',
      'React Testing Library',
      'Lazy Loading',
      'Memoization',
    ],
    images: [
      {
        id: 'iuhsdhvuas',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738344613/cvapp2025/bbc-news-app/IMG_1049.jpg',
        alt: 'BBC Mobile App',
      },
      {
        id: 'fgfgf',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738344613/cvapp2025/bbc-news-app/IMG_1050.jpg',
        alt: 'BBC Mobile App',
      },
      {
        id: 'trtrthgf',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738344614/cvapp2025/bbc-news-app/IMG_1051.jpg',
        alt: 'BBC Mobile App',
      },
      {
        id: '455rtrgbsrv',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738344613/cvapp2025/bbc-news-app/IMG_1052.jpg',
        alt: 'BBC Mobile App',
      },
      {
        id: 'yereyytehb',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738344613/cvapp2025/bbc-news-app/IMG_1056.jpg',
        alt: 'BBC Mobile App',
      },
      {
        id: 'uyijhgythg',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738344612/cvapp2025/bbc-news-app/IMG_1057.jpg',
        alt: 'BBC Mobile App',
      },
      {
        id: 'yttytyedtyd',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738344610/cvapp2025/bbc-news-app/IMG_1055.jpg',
        alt: 'BBC Mobile App',
      },
      {
        id: 'tryujyjh',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738344610/cvapp2025/bbc-news-app/IMG_1058.jpg',
        alt: 'BBC Mobile App',
      },
      {
        id: 'iushdihufsda',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738344610/cvapp2025/bbc-news-app/IMG_1059.jpg',
        alt: 'BBC Mobile App',
      },
      {
        id: 'ppppwek',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738344609/cvapp2025/bbc-news-app/IMG_1060.jpg',
        alt: 'BBC Mobile App',
      },
    ],
  },
  {
    id: 'oisahdygff',
    url: 'bbc-news-website',
    title: 'BBC News Website',
    galleryHeight: 200,
    shortDescription:
      'The BBC News Website redesign offers a seamless way to access live and archived news, optimized for desktop and mobile with a dynamic, intuitive user experience.',
    description: `<p>The <b>BBC News Website</b> was redesigned to offer users a more seamless and engaging way to access live and archived news across both <b>desktop and mobile</b> platforms. The goal was to present the news in a <b>visually appealing and intuitive layout</b>, with an emphasis on making content easy to navigate while maintaining the BBC’s trusted brand.</p>
<br />
<p>As a <b>Software Developer</b>, I was responsible for <b>frontend development</b>, focusing on <b>building UI components, improving the overall user experience, and implementing business logic</b> to make the site as performant as possible.</p>
<br />
<p>Developed in collaboration with a team of talented <b>engineers, designers, project managers, and analysts</b>, this was a challenging but incredibly rewarding project, requiring <b>advanced technical skills</b> and an <b>attention to detail</b> to deliver the best possible user experience.</p>
<br />
<p>The site was built using <b>React.js</b> and <b>Styled Components</b>, ensuring a highly maintainable, efficient, and responsive UI. It integrates with the <b>BBC API</b> to pull in live data, with <b>real-time updates</b> throughout the site. The use of <b>Context API</b> allowed us to manage state effectively, while <b>TypeScript</b> provided the necessary type safety to ensure a smooth development process.</p>
<br />
<p>We used <b>Storybook</b> for <b>UI component development and documentation</b>, allowing for isolated component testing and easier collaboration across teams. This also helped us create a robust UI library for future scalability.</p>
<br />
<p>Performance optimization was a key focus—by implementing <b>lazy loading</b> for key parts of the site and utilizing <b>memoization</b>, we were able to significantly reduce load times and improve overall efficiency. We used <b>React Testing Library</b> to ensure high-quality, reliable code that would perform well in production.</p>
<br />
<p>One of the major challenges was ensuring <b>seamless video streaming</b> across both <b>desktop and mobile</b> devices. We created <b>custom modules and optimizations</b> to guarantee smooth playback, regardless of device. Additionally, we employed <b>animations and transitions</b> to create a more dynamic, intuitive user experience.</p>
<br />
<p>The results were remarkable—the new version of the website was considered a <b>huge success by BBC</b>, with millions of users engaging with the content on a daily basis. The success of the project was recognized with a <b>Silver Award at the 2024 BIMA Awards in the UX category</b>.</p>
`,
    technologies: [
      'React.js',
      'Next.js',
      'TypeScript',
      'Context API',
      'Styled Components',
      'React Testing Library',
      'Lazy Loading',
      'Memoization',
    ],
    images: [
      {
        id: 'iuhsdhvuas',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738690045/cvapp2025/bbc-news-website/bbc_web_2025-02-04_at_18.16.17.jpg',
        alt: 'BBC News Website',
      },
      {
        id: 'sssssssss',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738690045/cvapp2025/bbc-news-website/bbc_web_2025-02-04_at_18.14.52.jpg',
        alt: 'BBC News Website',
      },
      {
        id: 'aaaaaaa',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738690044/cvapp2025/bbc-news-website/bbc_web_2025-02-04_at_18.20.04.jpg',
        alt: 'BBC News Website',
      },
      {
        id: 'wwwwww',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738690044/cvapp2025/bbc-news-website/bbc_web_2025-02-04_at_18.15.41.jpg',
        alt: 'BBC News Website',
      },
      {
        id: 'tttttt',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738690044/cvapp2025/bbc-news-website/bbc_web_2025-02-04_at_18.17.24.jpg',
        alt: 'BBC News Website',
      },
      {
        id: 'qqqqqqq',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738690043/cvapp2025/bbc-news-website/bbc_web_2025-02-04_at_18.18.14.jpg',
        alt: 'BBC News Website',
      },
      {
        id: 'uhsdhdshuasu',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738690042/cvapp2025/bbc-news-website/bbc_web_2025-02-04_at_18.19.29.jpg',
        alt: 'BBC News Website',
      },
      {
        id: 'lkiuythty',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738690042/cvapp2025/bbc-news-website/bbc_web_2025-02-04_at_18.16.45.jpg',
        alt: 'BBC News Website',
      },
      {
        id: 'hyhyjyjjy',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738690042/cvapp2025/bbc-news-website/bbc_web_2025-02-04_at_18.17.49.jpg',
        alt: 'BBC News Website',
      },
      {
        id: 'ggggggggg',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738690040/cvapp2025/bbc-news-website/bbc_web_2025-02-04_at_18.18.38.jpg',
        alt: 'BBC News Website',
      },
      {
        id: 'lllllllll',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738690038/cvapp2025/bbc-news-website/bbc_web_2025-02-04_at_18.21.28.jpg',
        alt: 'BBC News Website',
      },
      {
        id: 'iffjoerru',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738690038/cvapp2025/bbc-news-website/bbc_web_2025-02-04_at_18.20.44.jpg',
        alt: 'BBC News Website',
      },
      {
        id: 'redfgyuhgrt',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738690038/cvapp2025/bbc-news-website/bbc_web_2025-02-04_at_18.19.03.jpg',
        alt: 'BBC News Website',
      },
      {
        id: 'ghbvdtrgf',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738690035/cvapp2025/bbc-news-website/bbc_web_2025-02-04_at_18.23.10.jpg',
        alt: 'BBC News Website',
      },
      {
        id: 'nhgfbvhgffddf',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738690035/cvapp2025/bbc-news-website/bbc_web_2025-02-04_at_18.23.33.jpg',
        alt: 'BBC News Website',
      },
      {
        id: 'bbvbvvbbv',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738690035/cvapp2025/bbc-news-website/bbc_web_2025-02-04_at_18.21.55.jpg',
        alt: 'BBC News Website',
      },
      {
        id: 'equaddass',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738690673/cvapp2025/bbc-news-website/Screenshot_2025-02-04_at_18.37.38.jpg',
        alt: 'BBC News Website',
      },
    ],
  },
  {
    id: 'weewerfdsrfd',
    url: 'nep-mediabank',
    title: 'NEP Mediabank',
    galleryHeight: 50,
    shortDescription:
      'NEP Mediabank is a cloud-based media asset management platform enabling live ingest, automation, real-time collaboration, and instant clip creation for live events.',
    description: `<p><b>NEP Mediabank</b> is a leading <b>media asset management platform</b> that has powered the world’s largest <b>live and near-live productions</b> for over 15 years. Designed as a <b>cloud-based solution</b>, it enables enterprises to <b>manage less and monetize more</b> with intuitive search, live ingest, automation, and real-time collaboration.</p>
<br />
<p>With the help of this platform, companies can <b>not only manage and categorize their media assets</b> but also <b>edit them</b> by creating shorter clips. The app features a <b>video timeline</b> where users can mark key events—such as goals, yellow cards, or fouls—and instantly generate highlight clips using simple shortcuts. This makes the platform an essential tool for <b>live event productions</b>.</p>
<br />
<p>The app is widely used by major sports organizations such as <b>UEFA, MLS, Bundesliga, Sportradar, Rikstoto, and Eurosport</b>, playing a crucial role in <b>sports broadcasting</b>. Given its adoption across various industries, the UI needed to be <b>highly practical, customizable, and feature-rich</b> while maintaining ease of use.</p>
<br />
<p>As a <b>Software Developer</b> on this project, I focused on <b>frontend development</b>, building <b>feature-rich UI components</b> and optimizing performance to ensure a smooth user experience. I worked extensively with <b>React.js</b> and <b>JavaScript</b>, implementing a highly interactive and scalable interface. The app's styling was handled using <b>Styled Components</b>, with components heavily customized from a <b>Material UI</b> base to meet business needs.</p>
<br />
<p><b>State management</b> was powered by <b>Redux</b>, which introduced significant complexity due to the application's dynamic nature. One of the biggest challenges was structuring and maintaining a highly scalable Redux store to handle vast amounts of media data efficiently.</p>
<br />
<p>To improve performance, we implemented <b>memoization</b> and <b>lazy loading</b>, significantly reducing rendering overhead and enhancing responsiveness. Additionally, I contributed to <b>testing efforts</b> by writing robust test cases using <b>Jest</b> and <b>Cypress</b> to ensure the stability and reliability of the application.</p>
`,
    technologies: [
      'React.js',
      'JavaScript',
      'Redux',
      'Styled Components',
      'Jest',
      'Cypress',
      'Material UI',
      'Lazy Loading',
      'Memoization',
    ],
    images: [
      {
        id: 'iuhsdhvuas',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738753601/cvapp2025/nep_mediabank/Screenshot_2025-02-05_at_12.03.10.jpg',
        alt: 'NEP Mediabank',
      },
      {
        id: 'idfuhiudsh',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738753601/cvapp2025/nep_mediabank/Screenshot_2025-02-05_at_12.06.19.jpg',
        alt: 'NEP Mediabank',
      },
    ],
  },
  {
    id: 'cxcxcxcxcxcx',
    url: 'spectral',
    title: 'SPECTRAL',
    galleryHeight: 200,
    shortDescription:
      "SPECTRAL's new website and CMS showcase their high-end VFX work for Netflix & Apple TV, featuring a horizontal scrolling layout and a custom dashboard.",
    description: `<p><b>SPECTRAL</b> is a high-end <b>Visual Effects Studio</b> specializing in film and television productions. They collaborate with major studios like <b>Netflix</b> and <b>Apple TV</b> to create stunning visual effects for blockbuster movies and hit TV shows.</p>
<br />
<p>To showcase their work and manage their content efficiently, SPECTRAL needed a <b>website and a CMS</b> that would give them full control over their digital presence. Our solution delivered both—a highly visual, elegant website and an intuitive dashboard for content management.</p>
<br />
<p>As a <b>Frontend Developer</b> on the project, I played a key role in bringing the design to life. The website was built using the latest version of <b>Next.js</b> with <b>TypeScript</b>, styled using <b>Styled Components</b>. To elevate the user experience, I implemented <b>smooth animations</b> with <b>Framer Motion</b>, adding fluid transitions that complemented the studio’s cutting-edge visual effects work.</p>
<br />
<p>One of the biggest challenges was making the site fully <b>responsive</b>. On <b>desktop</b>, the layout features a <b>horizontal scrolling experience</b>, requiring precise scroll tracking for smooth interactions. On <b>mobile</b>, the site switches to a traditional <b>vertical scrolling</b> layout, ensuring accessibility across all devices.</p>
<br />
<p>In addition to the website, we built a custom <b>dashboard</b> for content management. The dashboard’s data was sourced via <b>GraphQL</b> and displayed using fully <b>custom UI components</b>, designed for an optimal balance between <b>feature richness</b> and <b>ease of use</b>.</p>
<br />
<p>Performance was a top priority across both the website and dashboard. To ensure smooth loading times and a seamless experience, we implemented <b>lazy loading</b> and <b>memoization</b>, optimizing performance without compromising on visual quality.</p>
`,
    technologies: [
      'React.js',
      'TypeScript',
      'Context API',
      'Styled Components',
      'Next.js',
      'Lazy Loading',
      'Memoization',
    ],
    images: [
      {
        id: 'iuhsdhvuas1',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738691393/cvapp2025/spectral/Screenshot_2025-02-04_at_18.41.03.jpg',
        alt: 'Specral Website',
      },
      {
        id: 'uihgdfsiush2',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738691393/cvapp2025/spectral/Screenshot_2025-02-04_at_18.40.45.jpg',
        alt: 'Specral Website',
      },
      {
        id: 'iuhfdiuhg3',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738691390/cvapp2025/spectral/Screenshot_2025-02-04_at_18.43.24.jpg',
        alt: 'Specral Website',
      },
      {
        id: 'fuvdhiufhv4',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738691390/cvapp2025/spectral/Screenshot_2025-02-04_at_18.41.27.jpg',
        alt: 'Specral Website',
      },
      {
        id: 'kjfuvb5',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738691389/cvapp2025/spectral/Screenshot_2025-02-04_at_18.41.45.jpg',
        alt: 'Specral Website',
      },
      {
        id: 'ioitroah6',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738691388/cvapp2025/spectral/Screenshot_2025-02-04_at_18.42.24.jpg',
        alt: 'Specral Website',
      },
      {
        id: 'fudgsh7',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738691387/cvapp2025/spectral/Screenshot_2025-02-04_at_18.42.47.jpg',
        alt: 'Specral Website',
      },
      {
        id: 'oadhfvcftd8',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738691386/cvapp2025/spectral/Screenshot_2025-02-04_at_18.44.45.jpg',
        alt: 'Specral Website',
      },
      {
        id: 'oreiuh9',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738691386/cvapp2025/spectral/Screenshot_2025-02-04_at_18.43.58.jpg',
        alt: 'Specral Website',
      },
      {
        id: 'idfuhiufh10',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738691384/cvapp2025/spectral/Screenshot_2025-02-04_at_18.44.26.jpg',
        alt: 'Specral Website',
      },
      {
        id: 'oisdfghj11',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738691384/cvapp2025/spectral/Screenshot_2025-02-04_at_18.45.48.jpg',
        alt: 'Specral Website',
      },
      {
        id: 'sfgdij12',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738691383/cvapp2025/spectral/Screenshot_2025-02-04_at_18.46.31.jpg',
        alt: 'Specral Website',
      },
      {
        id: 'sdfiuhdivu13',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738691383/cvapp2025/spectral/Screenshot_2025-02-04_at_18.48.12.jpg',
        alt: 'Specral Website',
      },
      {
        id: 'dfviuh14',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738691383/cvapp2025/spectral/Screenshot_2025-02-04_at_18.47.29.jpg',
        alt: 'Specral Website',
      },
      {
        id: 'didfuhvvidh15',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738691382/cvapp2025/spectral/Screenshot_2025-02-04_at_18.48.43.jpg',
        alt: 'Specral Website',
      },
    ],
  },
  {
    id: 'uiuiuiiuii',
    url: 'greenline-clean',
    title: 'GreenLine Clean',
    galleryHeight: 2500,
    shortDescription:
      "GreenLine Clean's CMS optimizes washer scheduling, efficiency tracking, and customer management, featuring a custom calendar system and a highly responsive UI.",
    description: `<p><b>GreenLine Clean</b> is Hungary’s leading <b>premium water-saving car wash network</b>, offering eco-friendly car cleaning services through a seamless mobile app. To optimize their operations, they needed a <b>CMS dashboard</b> to manage their washers, schedule shifts, and track service efficiency.</p>
<br />
<p>The CMS was designed to handle <b>employee scheduling</b>, allowing managers to view and adjust availability in real-time. Additionally, the system tracked how long each wash took, helping to improve operational efficiency and resource allocation.</p>
<br />
<p>As a <b>Frontend Developer</b>, I was responsible for building the dashboard using <b>React.js</b>, <b>TypeScript</b>, and <b>Styled Components</b>. The UI was based on <b>Material UI</b>, but heavily customized to align with GreenLine Clean’s branding and usability requirements.</p>
<br />
<p>The biggest challenge of the project was implementing a highly functional <b>calendar system</b>, as most of the scheduling and management features were tied to it. The CMS also included <b>customer data management</b>, requiring a balance between complexity and ease of use.</p>
<br />
<p>To ensure high performance and smooth user interactions, I implemented <b>lazy loading</b> and <b>memoization</b>, reducing unnecessary re-renders and optimizing load times. State management was handled using the <b>Context API</b>, providing a lightweight yet efficient solution.</p>
`,
    technologies: [
      'React.js',
      'TypeScript',
      'Context API',
      'Styled Components',
      'Framer Motion',
      'Lazy Loading',
      'Memoization',
    ],
    images: [],
  },
  {
    id: 'jujujuujujj',
    url: 'farkastent',
    title: 'FarkasTent',
    galleryHeight: 150,
    shortDescription:
      'FarkasTent’s webshop offers an easy way to purchase or rent motorsports tents, with a CMS for content management and optimized performance for a seamless experience.',
    description: `<p><b>FarkasTent</b> is a Hungarian company specializing in <b>high-quality tents for motorsports teams</b>. They needed a <b>webshop</b> that was easy to navigate, allowing customers to seamlessly purchase or rent tents, along with a <b>CMS dashboard</b> to manage and customize the webshop’s content.</p>
<br />
<p>We developed a <b>fast and user-friendly webshop</b> using <b>Next.js</b>, while the CMS dashboard was built with <b>React.js</b> and <b>TypeScript</b>. Styled Components was used for styling, ensuring a clean and maintainable codebase.</p>
<br />
<p>As a <b>Frontend Developer</b>, I was responsible for crafting the <b>UI of both the webshop and the CMS</b>, ensuring a smooth shopping experience and an intuitive management system. Additionally, I implemented key <b>business logic</b> for the webstore, handling purchases, rentals, and content updates.</p>
<br />
<p>Performance was a top priority, so we optimized the platform using <b>lazy loading</b> and <b>memoization</b>, ensuring fast load times and a seamless user experience.</p>
`,
    technologies: [
      'React.js',
      'TypeScript',
      'Context API',
      'Styled Components',
      'Framer Motion',
      'Docker containers',
      'Lazy Loading',
      'Memoization',
    ],
    images: [
      {
        id: 'iuhsdhvuas1',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738753748/cvapp2025/farkastent/Screenshot_2025-02-05_at_11.46.49.jpg',
        alt: 'FarkasTent',
      },
      {
        id: 'sduihsad2',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738753746/cvapp2025/farkastent/Screenshot_2025-02-05_at_11.47.36.jpg',
        alt: 'FarkasTent',
      },
      {
        id: 'sdkuhsd3',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738753747/cvapp2025/farkastent/Screenshot_2025-02-05_at_11.47.13.jpg',
        alt: 'FarkasTent',
      },
      {
        id: 'ijgkfijvf4',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738753746/cvapp2025/farkastent/Screenshot_2025-02-05_at_11.48.37.jpg',
        alt: 'FarkasTent',
      },
      {
        id: 'fdauihbjn5',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738753745/cvapp2025/farkastent/Screenshot_2025-02-05_at_11.49.33.jpg',
        alt: 'FarkasTent',
      },
      {
        id: 'dsiuhfj6',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738753744/cvapp2025/farkastent/Screenshot_2025-02-05_at_11.52.39.jpg',
        alt: 'FarkasTent',
      },
      {
        id: 'dskjnjd7',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738753743/cvapp2025/farkastent/Screenshot_2025-02-05_at_11.52.58.jpg',
        alt: 'FarkasTent',
      },
      {
        id: 'dsfiohsiudfh8',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738753743/cvapp2025/farkastent/Screenshot_2025-02-05_at_11.53.21.jpg',
        alt: 'FarkasTent',
      },
      {
        id: 'sdbhsbsfd9',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738753742/cvapp2025/farkastent/Screenshot_2025-02-05_at_11.53.42.jpg',
        alt: 'FarkasTent',
      },
      {
        id: 'dsfhdsuds10',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738753742/cvapp2025/farkastent/Screenshot_2025-02-05_at_11.55.23.jpg',
        alt: 'FarkasTent',
      },
      {
        id: 'dshdsiu11',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738753742/cvapp2025/farkastent/Screenshot_2025-02-05_at_11.54.24.jpg',
        alt: 'FarkasTent',
      },
    ],
  },
  {
    id: 'lpllppllplpllp',
    url: 'unleash',
    title: 'Unleash',
    galleryHeight: 140,
    shortDescription:
      'Unleash is a global HR-Tech leader connecting innovators and top exhibitors through dynamic, SEO-optimized web solutions built with React and Node.js.',
    description: `<p><b>Unleash</b> is a highly reputable company in the HR market, renowned for its innovative approach to connecting people and enriching workplace culture while enhancing work-life balance. Their global <b>HR-Tech shows</b> have taken center stage in cities like <b>London, Las Vegas, Paris, and Amsterdam</b>, featuring industry pioneers such as <b>Sir Richard Branson, Gary Vaynerchuk, and Esther Perel</b>, alongside top exhibitors including <b>Microsoft, Workday, and SAP</b>.</p>
<br />
<p>As a <b>Frontend Developer</b>, I was responsible for shaping the company’s online web experience across multiple sites and dashboard applications. These dynamic systems were built to adapt to the ever-changing needs of the business using cutting-edge technologies. Leveraging multiple <b>Node.js</b> backends and a wide array of <b>React</b> clients and dashboards, we exceeded expectations with fast load times and top-notch SEO optimizations.</p>
<br />
<p>Our solutions ranged from projects built with <b>create-react-app</b> to those developed with <b>Next.js</b>, all utilizing <b>Styled Components</b> for tailored UI customization. In the client-facing website, I implemented <b>Framer Motion</b> to achieve natural, spring physics-based animations. The projects were crafted with both <b>TypeScript</b> and <b>JavaScript</b>, ensuring a robust and versatile codebase.</p>
`,
    technologies: [
      'React.js',
      'TypeScript',
      'Context API',
      'Docker containers',
      'Framer Motion',
      'Styled Components',
      'Lazy Loading',
      'Memoization',
    ],
    images: [
      {
        id: 'iuhsdhvuas1',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738754769/cvapp2025/unleash/Screenshot_2025-02-05_at_12.17.41.jpg',
        alt: 'Unleash website',
      },
      {
        id: 'iuhsdhvuas2',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738754768/cvapp2025/unleash/Screenshot_2025-02-05_at_12.18.01.jpg',
        alt: 'Unleash website',
      },
      {
        id: 'iuhsdhvuas3',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738754767/cvapp2025/unleash/Screenshot_2025-02-05_at_12.18.53.jpg',
        alt: 'Unleash website',
      },
      {
        id: 'iuhsdhvuas4',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738754766/cvapp2025/unleash/Screenshot_2025-02-05_at_12.19.16.jpg',
        alt: 'Unleash website',
      },
      {
        id: 'iuhsdhvuas5',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738754766/cvapp2025/unleash/Screenshot_2025-02-05_at_12.20.05.jpg',
        alt: 'Unleash website',
      },
      {
        id: 'iuhsdhvuas6',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738754765/cvapp2025/unleash/Screenshot_2025-02-05_at_12.20.20.jpg',
        alt: 'Unleash website',
      },
      {
        id: 'iuhsdhvuas7',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738754764/cvapp2025/unleash/Screenshot_2025-02-05_at_12.20.40.jpg',
        alt: 'Unleash website',
      },
      {
        id: 'iuhsdhvuas8',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738754763/cvapp2025/unleash/Screenshot_2025-02-05_at_12.21.31.jpg',
        alt: 'Unleash website',
      },
      {
        id: 'iuhsdhvuas9',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738754762/cvapp2025/unleash/Screenshot_2025-02-05_at_12.21.45.jpg',
        alt: 'Unleash website',
      },
      {
        id: 'iuhsdhvuas10',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738754762/cvapp2025/unleash/Screenshot_2025-02-05_at_12.22.30.jpg',
        alt: 'Unleash website',
      },
      {
        id: 'iuhsdhvuas11',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738754761/cvapp2025/unleash/Screenshot_2025-02-05_at_12.22.55.jpg',
        alt: 'Unleash website',
      },
      {
        id: 'iuhsdhvuas12',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738754760/cvapp2025/unleash/Screenshot_2025-02-05_at_12.23.53.jpg',
        alt: 'Unleash website',
      },
      {
        id: 'iuhsdhvuas13',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738754760/cvapp2025/unleash/Screenshot_2025-02-05_at_12.23.18.jpg',
        alt: 'Unleash website',
      },
      {
        id: 'iuhsdhvuas14',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738754759/cvapp2025/unleash/Screenshot_2025-02-05_at_12.24.19.jpg',
        alt: 'Unleash website',
      },
      {
        id: 'iuhsdhvuas15',
        url:
          'https://res.cloudinary.com/nahov91/image/upload/v1738754759/cvapp2025/unleash/Screenshot_2025-02-05_at_12.24.37.jpg',
        alt: 'Unleash website',
      },
    ],
  },
]
